<template>
  <div v-if="details">
    <div class="row">
      <div class="col-md-8">
        <b-card header="Çıkış Süreci Detayları" class="mb-1 ">
          <table class="table table-sm table-striped table-bordered mb-0">
            <tbody>
              <tr>
                  <th class="w-35 text-nowrap">SGK Şubesi</th>
                  <td>{{ details.BranchName || '-' }}</td>
              </tr>
              <tr>
                  <th class="text-nowrap">İşten Çıkış Ana Nedeni</th>
                  <td>{{ details.ParentJobExitSpecialCauseName || '-' }}</td>
              </tr>
              <tr>
                  <th class="text-nowrap">İşten Çıkış Sebebi</th>
                  <td>{{ cikisSebebiText }}</td>
              </tr>
              <tr>
                  <th class="text-nowrap">İşten Çıkış Özel Nedeni</th>
                  <td>{{ details.JobExitSpecialCauseName || '-' }}</td>
              </tr>
              <tr>
                  <th class="text-nowrap">Tebliğ Tarihi</th>
                  <td>{{ details.NotifyDate | dateFormatter }}</td>
              </tr>
              <tr>
                  <th class="text-nowrap">İsten Çıkış Tarihi</th>
                  <td>{{ details.istenCikisTarihi | dateFormatter }}</td>
              </tr>
              <tr>
                  <th class="text-nowrap">İhbar Durumu</th>
                  <td class="font-weight-bold text-nowrap">{{ ihbarDurumuText }}</td>
              </tr>
          </tbody>
          </table>
        </b-card>

        <b-card header="Ek Bilgiler">
          <table class="table table-sm table-striped table-bordered mb-0">
            <tbody>
              <tr>
                  <th class="w-50 text-nowrap">Şirkete Borcu</th>
                  <td>{{ details.SirketeBorcu ? details.SirketeBorcu.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' }) : 'Yok' }}</td>
              </tr>
              <tr>
                  <th class="text-nowrap">İcra/Haciz Durumu</th>
                  <td><b-badge :variant="details.HasLevy ? 'danger' : 'success'">{{ details.HasLevy | booleanFormatter }}</b-badge></td>
              </tr>
              <tr>
                  <th class="text-nowrap">İşe Alımı Sakıncalı Mı?</th>
                  <td><b-badge :variant="details.Harmful ? 'danger' : 'success'">{{ details.Harmful | booleanFormatter }}</b-badge></td>
              </tr>
              <tr v-if="$safe(details,'Harmful') && $safe(detail,'HarmfulReason')">
                  <th class="text-nowrap">Sakınca Nedeni</th>
                  <td>{{ $safe(detail,'HarmfulReason') }}</td>
              </tr>
              <tr>
                  <th class="text-nowrap">Sürücü Personel Mi?</th>
                  <td>{{ details.Driver | booleanFormatter }}</td>
              </tr>
              <tr>
                  <th class="text-nowrap">EYT Statüsünde Mi?</th>
                  <td>{{ details.EYT | booleanFormatter }}</td>
              </tr>
              <tr>
                  <th class="text-nowrap">İhtarname Durumu</th>
                  <td>
                      <span v-if="details.Ihtar">
                          Var - <a :href="details.IhtarFilePath" target="_blank" class="font-weight-bold">Dosyayı Görüntüle</a>
                      </span>
                      <span v-else>Yok</span>
                  </td>
              </tr>
              <tr>
                  <th class="text-nowrap">Vukuat Var Mı?</th>
                  <td><b-badge :variant="details.Vukuat ? 'warning' : 'success'">{{ details.Vukuat | booleanFormatter }}</b-badge></td>
              </tr>
              <tr v-if="details.Vukuat">
                  <th class="text-nowrap">Vukuat Açıklaması</th>
                  <td>{{ details.VukuatAciklama }}</td>
              </tr>
          </tbody>
          </table>
        </b-card>
      </div>

      <div class="col-md-4">
        <div v-if="details.ApprovalStatuses && details.ApprovalStatuses.length > 0">
          <b-card header="Onay Süreci Geçmişi" class="h-100" body-class="d-flex flex-column">
            <div v-for="(cycle, i) in formattedApprovalStatuses" :key="`cycle-${cycle.CycleIndex}`" :class="{'mt-2': i > 0}">
                <div class="border rounded overflow-hidden">
                    <div :class="['px-1 py-50 font-weight-bolder d-flex justify-content-between align-items-center', cycle.CycleIndex !== maxCycle ? 'text-muted':'bg-light-primary']" v-b-toggle="`cycle-collapse-${i}`" >
                        <span>{{(cycle.CycleIndex + 1)}}. Tur</span>  
                        <div class="d-flex align-items-center">
                            <b-badge :variant="getCycleStatus(cycle).variant" class="mr-1">{{ getCycleStatus(cycle).text }}</b-badge>
                            <feather-icon icon="ChevronDownIcon" />
                        </div>
                    </div>
                    <b-collapse :visible="cycle.CycleIndex === maxCycle" :id="`cycle-collapse-${i}`">
                        <div class="border-top p-1">
                            <div v-for="(levelGroup, ii) in cycle.LevelsGrouped" :key="`level-group-${ii}`" :class="{'mt-1': ii > 0}">
                                <div class="bg-light rounded text-dark mb-1 px-1 py-50">
                                    {{ levelGroup.Level }}. Seviye
                                </div>
                                <app-timeline>
                                    <app-timeline-item 
                                        v-for="(approver, index) in levelGroup.Levels" 
                                        :key="`approver-${index}`" 
                                        :variant="getVariantForTimeline(approver.ApprovalStatusType)"
                                        :title="approver.ApproverUserFullName" 
                                        :subtitle="getSubtitleForTimeline(approver.ApprovalStatusType)" 
                                        :time="approver.Date ? $options.filters.dateFormatter(approver.Date, true) : ''"
                                        :description="approver.Description"
                                    />
                                </app-timeline>
                            </div>
                        </div>
                    </b-collapse>
                </div>
            </div>
            <div class="text-right text-muted font-italic small mt-1 mb-0">
                Toplam Tur Sayısı: {{ formattedApprovalStatuses.length }}
            </div>
          </b-card> 
        </div>
        <b-alert v-else show variant="info">Bu çıkış işlemi için henüz bir onay geçmişi bulunmamaktadır.</b-alert>
        
    </div>
    </div>
  </div>
  <b-alert v-else show variant="warning">Detay bilgileri yüklenemedi.</b-alert>
</template>

<script>
import { BAlert, BBadge, BCard, BCollapse, VBToggle } from 'bootstrap-vue'
import AppTimeline from '@/@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@/@core/components/app-timeline/AppTimelineItem.vue'

export default {
    components: {
        BAlert,
        BBadge,
        BCard,
        BCollapse,
        AppTimeline,
        AppTimelineItem
    },
    directives:{
        'b-toggle':VBToggle
    },
    props: {
        details: {
            type: Object,
            default: null
        }
    },
    computed: {
        ihbarDurumuText() {
            if (!this.details) return 'Bilgi Yok';
            if (this.details.IhbarOneliKullanacak) {
                const sureTipi = this.details.IhbarOneliWorkDay ? 'İş Günü' : 'Hafta';
                return `İhbar Süresini Kullanacak (${this.details.IhbarOneliSuresi} ${sureTipi})`;
            }
            return 'İhbar Tazminatı Ödenecek';
        },
        cikisSebebiText() {
            const code = this.details.istenCikisNedeni;
            const name = this.details.JobExitCauseName;

            if (code && name) return `${code} - ${name}`;
            return code || name || '-';
        },
        maxCycle(){
            if(!this.details || !this.details.ApprovalStatuses) return 0;
            return Math.max(...this.details.ApprovalStatuses.map(s => s.CycleIndex),0)
        },
        formattedApprovalStatuses() {
            if (!this.details || !this.details.ApprovalStatuses) {
                return [];
            }
            const groupedByCycle = this.details.ApprovalStatuses.reduce((acc, current) => {
                if (!acc[current.CycleIndex]) {
                    acc[current.CycleIndex] = {
                        CycleIndex: current.CycleIndex,
                        LevelsGrouped: []
                    };
                }
                acc[current.CycleIndex].LevelsGrouped.push(...current.LevelsGrouped);
                
                return acc;
            }, {});
            return Object.values(groupedByCycle).sort((a, b) => a.CycleIndex - b.CycleIndex);
        } 
    },
    methods: {
        getCycleStatus(cycle) {
            const allLevels = cycle.LevelsGrouped.flatMap(levelGroup => levelGroup.Levels);
            if (allLevels.some(approver => approver.ApprovalStatusType === 2)) {
                return { text: 'Reddedildi', variant: 'danger' };
            }
            if (allLevels.some(approver => approver.ApprovalStatusType === 0)) {
                return { text: 'Onay Sürecinde', variant: 'warning' };
            }
            return { text: 'Tamamlandı', variant: 'success' };
        },
        getSubtitleForTimeline(type){
            if(type === 0) return 'Onay Bekliyor'
            if(type === 1) return 'Onaylandı'
            if(type === 2) return 'Reddedildi'
            return 'Bilinmiyor'
        },
        getVariantForTimeline(type){
            if(type === 0) return 'warning'
            if(type === 1) return 'success'
            if(type === 2) return 'danger'
            return 'secondary'
        }
    },
    filters: {
        booleanFormatter(val) {
            return val ? 'Evet' : 'Hayır';
        },
        dateFormatter(value, withTime = false) {
            if (!value) return '';
            const date = new Date(value);
            if (isNaN(date)) return value;
            const options = {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            };
            if (withTime) {
                options.hour = '2-digit';
                options.minute = '2-digit';
            }
            return date.toLocaleDateString('tr-TR', options);
        }
    }
}
</script>

<style>
</style>